<div (window:resize)="detectWindowSize()">
  <router-outlet></router-outlet>
</div>